var _defs, _rect, _polyline, _polyline2, _polyline3, _polyline4, _polyline5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganizations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #d6002e;\n        stroke-miterlimit: 10;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "15.7473 18.1027 17.4127 18.1027 17.4127 9.5703 12 4.4433 6.5873 9.5703 6.5873 18.1027 16.0995 18.1027"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "21.9856 17.4127 21.9856 21.9856 17.4127 21.9856"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.4127 2.0144 21.9856 2.0144 21.9856 6.5873"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "2.0144 6.5873 2.0144 2.0144 6.5873 2.0144"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "6.5873 21.9856 2.0144 21.9856 2.0144 17.4127"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizations);
export default __webpack_public_path__ + "static/media/organizations.416c79df.svg";
export { ForwardRef as ReactComponent };